import React from 'react';
// NEW imports at top
// import { BrowserRouter, Routes, Route, Link as RouterLink } from 'react-router-dom';

import { BrowserRouter, Routes, Route, Link as RouterLink } from "react-router-dom";
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Contact from './pages/Contact';
import {
  AppBar, Toolbar, Typography, Container, CssBaseline, Box, Paper, Button, IconButton, Tooltip,
  Tabs, Tab, TextField, CircularProgress, Grid, Accordion, AccordionSummary, AccordionDetails,
  Alert, Snackbar, Card, CardContent   // ← added
} from '@mui/material';


import { createTheme, ThemeProvider } from '@mui/material/styles';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DownloadIcon from '@mui/icons-material/Download';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ReactMarkdown from 'react-markdown';
import { Helmet, HelmetProvider } from 'react-helmet-async';

// ⭐ MODIFIED: add supabase + auth
import { createClient, User, AuthChangeEvent, Session } from '@supabase/supabase-js';


const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL!,
  process.env.REACT_APP_SUPABASE_ANON_KEY!  
);

export default function App() {
  // ⭐ MODIFIED: new states
  const [user, setUser] = React.useState<User | null>(null);

  
  // existing states...
  const [url, setUrl] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [result, setResult] = React.useState('');
  const [summary, setSummary] = React.useState('');
  const [tabIndex, setTabIndex] = React.useState(0);
  const [darkMode, setDarkMode] = React.useState(false);

    // ⭐ NEW: toast for errors

  const displayName = (user?.user_metadata?.full_name as string) || (user?.email ?? "");
  const [toastOpen, setToastOpen] = React.useState(false);
  const [toastMsg, setToastMsg] = React.useState('');
  const [toastSeverity, setToastSeverity] = React.useState<'error'|'info'|'success'|'warning'>('error');

  const showError = (msg: string) => { setToastSeverity('error'); setToastMsg(msg); setToastOpen(true); };
  const showInfo  = (msg: string) => { setToastSeverity('info');  setToastMsg(msg); setToastOpen(true); };
  const [subscription, setSubscription] = React.useState<null | { plan: string, credits: number | null }>(null);

  // Helper to refresh plan/credits (used after actions to keep the badge in sync)
  const refreshSubscription = async () => {
    try {
      const token = (await supabase.auth.getSession()).data?.session?.access_token ?? '';
      const res = await fetch(`${API_BASE}/api/subscription-status`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!res.ok) return;
      const json = await res.json().catch(() => null);
      if (json) setSubscription(json);
    } catch {}
  };

  const isPaidPlan = (p?: string) => ['pro','ultimate'].includes((p || '').toLowerCase());
  const SHOW_AUTH_PANEL = false;

  // Show/Hide the auth panel if you want to toggle it via AppBar "Login" button,
  // or just set default true when !user.
  // const [showAuth, setShowAuth] = React.useState(false);

  // Email/password inputs
  const [authTab, setAuthTab] = React.useState<'login'|'signup'>('login');
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [authLoading, setAuthLoading] = React.useState(false);  

  // const API_BASE = "https://api.youtube-summarizer.pawtural.com";
  const API_BASE = process.env.REACT_APP_API_BASE ?? "http://localhost:8080";


  const theme = createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
    },
  });



  async function handleManageSubscription() {
    try {
      const { data } = await supabase.auth.getSession();
      const token = data?.session?.access_token;
      if (!token) { showError('Please log in first.'); return; }

      const res = await fetch(`${API_BASE}/api/create-portal-session`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });

      const body = await res.text().catch(() => '');
      if (!res.ok) { showError(body || `Failed to open billing portal (${res.status})`); return; }

      // ✅ Make the type explicit so TS knows `url` may be absent
      type PortalResp = { url?: string };
      const parsed: PortalResp = body ? JSON.parse(body) as PortalResp : {};
      const url = parsed.url;

      if (!url) { showError('No portal URL returned.'); return; }
      window.location.href = url;
    } catch (e) {
      showError('Could not open billing portal.');
    }
  }



    // ⭐ MODIFIED: auth state effect
  React.useEffect(() => {
    supabase.auth.getUser().then(({ data }) => setUser(data.user ?? null));

    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event: AuthChangeEvent, session: Session | null) => {
        setUser(session?.user ?? null);
      }
    );

    return () => listener.subscription.unsubscribe();
  }, []);




  React.useEffect(() => {
  let active = true;

  (async () => {
    if (!user) { setSubscription(null); return; }

    try {
      const { data } = await supabase.auth.getSession();
      const token = data?.session?.access_token ?? '';

      const res = await fetch(`${API_BASE}/api/subscription-status`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      const text = await res.text(); // always read body

      if (!active) return;

      if (!res.ok) {
        console.error('subscription-status failed:', res.status, text);
        setSubscription({ plan: 'error', credits: 0 });
        return;
      }

      // parse if non-empty, else treat as error so UI doesn’t stay "loading"
      const json = text ? JSON.parse(text) : null;
      if (!json || typeof json.plan === 'undefined') {
        console.error('subscription-status empty/invalid:', text);
        setSubscription({ plan: 'error', credits: 0 });
        return;
      }

      setSubscription(json); // { plan: "free"|"pro"|..., credits: number|-1 }
    } catch (e) {
      console.error('subscription-status exception:', e);
      if (active) setSubscription({ plan: 'error', credits: 0 });
    }
  })();

  return () => { active = false; };
}, [user, API_BASE]);


  // ⭐ MODIFIED: login/logout
  const handleLogin = async () => {
    const redirectTo =
      process.env.NODE_ENV === 'development'
        ? 'http://localhost:3000/'                               // dev: return to localhost
        : 'https://youtube-summarizer.pawtural.com/';            // prod: return to prod

    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo }
    });
    if (error) alert(error.message);
  };



  const handleLogout = () => supabase.auth.signOut();

  const handleSignUp = async () => {
    setAuthLoading(true);
    try {
      const { data, error } = await supabase.auth.signUp({ email, password });
      if (error) { showError(error.message); return; }
      if (!data.session) {
        showInfo('Check your email to confirm your account, then log in.');
      } else {
        showInfo('Signed up successfully.');
      }
    } catch {
      showError('Sign up failed.');
    } finally {
      setAuthLoading(false);
    }
  };




  const handleSignIn = async () => {
    setAuthLoading(true);
    try {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) { showError(error.message); return; }
      showInfo('Logged in.');
    } catch {
      showError('Login failed.');
    } finally {
      setAuthLoading(false);
    }
  };

  const handleResetPassword = async () => {
    setAuthLoading(true);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.origin, // or a dedicated /reset page
      });
      if (error) { showError(error.message); return; }
      showInfo('Password reset email sent.');
    } catch {
      showError('Could not send reset email.');
    } finally {
      setAuthLoading(false);
    }
  };






  // App.tsx — replace your handleSubscribe
  const handleSubscribe = async (plan: string = 'pro-monthly') => {
    try {
      const token = (await supabase.auth.getSession()).data?.session?.access_token;
      if (!token) { showError('Please log in first.'); return; }

      const res = await fetch(`${API_BASE}/api/create-checkout-session`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ plan }),
      });

      const text = await res.text();                 // <-- always read the body
      if (!res.ok) {                                 // <-- surface backend error
        showError(text || `Checkout failed (${res.status})`);
        return;
      }

      const { url } = JSON.parse(text) || {};
      if (!url) { showError('No checkout URL returned.'); return; }
      window.location.href = url;
    } catch {
      showError('Unable to start checkout.');
    }
  };


  const features = [
    { title: 'Summarize Long Videos', description: 'Condense lengthy content into digestible summaries.' },
    { title: 'Subtitle Translation (coming soon)', description: 'Translate subtitles into multiple languages.' },
    { title: 'Batch Processing (coming soon)', description: 'Process multiple videos efficiently.' },
  ];

  const steps = [
    { step: 'Step 1', title: 'Paste a YouTube link', desc: 'Copy the URL of the video you want to process.' },
    { step: 'Step 2', title: 'Click Generate', desc: 'Hit the button to begin summarizing or extracting.' },
    { step: 'Step 3', title: 'View/Download Result', desc: 'Access your summary and download it as needed.' },
  ];

  const testimonials = [
    { name: 'Ray Kerns', role: '📚 Teacher', quote: 'This tool saves me hours preparing lesson materials from YouTube!' },
    { name: 'Alex Kim', role: '🎓 Student', quote: 'A game-changer for studying lectures.' },
    { name: 'Sam Wu', role: '📰 Journalist', quote: 'Makes transcribing interviews so much faster.' },
  ];

  const faq = [
    { question: 'Is my data secure?', answer: 'Yes. We never store your video links or results.' },
    { question: 'How does the summarization work?', answer: 'We use advanced AI models to analyze and condense the content.' },
  ];


  
  const handleTabChange = (_: any, newValue: number) => {
    setTabIndex(newValue);
  };

  const handleGenerate = async () => {
    if (!url) return;
    setLoading(true);
    setResult('');
    setSummary('');
    setTabIndex(0);

    try {
      const token = (await supabase.auth.getSession()).data?.session?.access_token;

      const form = new FormData();
      form.append('youtube_url', url);
      form.append('filename', 'transcript.txt');

      const res = await fetch(`${API_BASE}/api/transcribe`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: form,
      });

      if (!res.ok) {
        const text = await res.text().catch(() => '');
        showError(text || `Transcribe failed (${res.status})`);
        return;
      }

      const data = await res.json().catch(() => null);
      if (!data?.success) { showError(data?.error ?? 'Unknown transcribe error'); return; }

      setResult(data.text);
      await refreshSubscription();
    } catch {
      showError('Error connecting to backend.');
    } finally {
      setLoading(false);
    }
  };


  const handleSummarize = async () => {
    if (!result) return; // require transcript first
    setLoading(true);
    setSummary('');

    try {
      const token = (await supabase.auth.getSession()).data?.session?.access_token;

      const form = new FormData();
      form.append('transcript', result);
      form.append('youtube_url', url);  // ⬅️ ADD THIS LINE

      const res = await fetch(`${API_BASE}/api/summarize`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: form,
      });

      if (!res.ok) {
        const text = await res.text().catch(() => '');
        showError(text || `Summarize failed (${res.status})`);
        return;
      }

      const data = await res.json().catch(() => null);
      if (!data?.success) { showError(data?.error ?? 'Unknown summarize error'); return; }

      setSummary(data.summary);
      setTabIndex(1);
      await refreshSubscription();
    } catch {
      showError('Error connecting to backend.');
    } finally {
      setLoading(false);
    }
  };


  // ▼ Replace your existing handleGenerateAndSummarize with this version
  const handleGenerateAndSummarize = async () => {
    if (!url) return;
    setLoading(true);
    setResult('');
    setSummary('');
    setTabIndex(0); // ★ CHANGED: ensure we start on the Transcript tab

    try {
      // ★ CHANGED: fetch the Supabase JWT once and reuse
      const token = (await supabase.auth.getSession()).data?.session?.access_token;

      const formData = new FormData();
      formData.append('youtube_url', url);
      formData.append('filename', 'transcript.txt');

      // ★ CHANGED: fail fast on non-2xx and surface toast
      const response = await fetch(`${API_BASE}/api/transcribe`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: formData,
      });

      // ★ CHANGED: handle HTTP errors before parsing JSON
      if (!response.ok) {
        const text = await response.text().catch(() => '');
        showError(text || `Transcribe failed (${response.status})`);
        return;
      }

      const data = await response.json().catch(() => null);

      // ★ CHANGED: use toast instead of writing "Error: ..." into state
      if (!data?.success) {
        showError(data?.error ?? 'Unknown transcribe error');
        return;
      }

      setResult(data.text);
      await refreshSubscription();

      // --- summarize step ---
      const summaryForm = new FormData();
      summaryForm.append('transcript', data.text);
      summaryForm.append('youtube_url', url);  // ⬅️ ADD THIS LINE

      const summaryResponse = await fetch(`${API_BASE}/api/summarize`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: summaryForm,
      });

      if (!summaryResponse.ok) {
        const text = await summaryResponse.text().catch(() => '');
        showError(text || `Summarize failed (${summaryResponse.status})`);
        return;
      }

      const summaryData = await summaryResponse.json().catch(() => null);

      if (!summaryData?.success) {
        showError(summaryData?.error ?? 'Unknown summarize error');
        return;
      }

      setSummary(summaryData.summary);
      setTabIndex(1); // show Summary tab
    } catch (err) {
      // ★ CHANGED: centralized network error toast
      showError('Error connecting to backend.');
    } finally {
      setLoading(false);
    }
  };


  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  const handleDownload = (text: string, filename: string) => {
    const blob = new Blob([text], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

return (
  <HelmetProvider>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Helmet>
          <title>YouTube Video Summarizer | Mtinnotech</title>
          <meta name="description" content="Summarize long YouTube videos, get transcripts, and download them instantly with Mtinnotech. Fast, private, free." />
          <meta property="og:title" content="YouTube Video Summarizer | Mtinnotech" />
          <meta property="og:description" content="Paste a YouTube link, get an AI-generated transcript and summary in seconds." />
          <meta property="og:image" content="https://YOURDOMAIN.com/preview.jpg" />
          <meta property="og:url" content="https://YOURDOMAIN.com" />
          <meta name="twitter:card" content="summary_large_image" />
          <script type="application/ld+json">{`
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [
                { "@type": "Question", "name": "Is my data secure?", "acceptedAnswer": { "@type": "Answer", "text": "Yes. We never store your video links or results." } },
                { "@type": "Question", "name": "Are there any usage limits?", "acceptedAnswer": { "@type": "Answer", "text": "You can process up to 30 videos per day for free." } },
                { "@type": "Question", "name": "How does the summarization work?", "acceptedAnswer": { "@type": "Answer", "text": "We use advanced AI models to analyze and condense the content." } }
              ]
            }
          `}</script>
        </Helmet>

        <CssBaseline />

        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>Mtinnotech</Typography>

            {/* Plan + Credits */}
            {user ? (
              <>
                {/* NEW: show name/email */}
                <Typography variant="body2" sx={{ mr: 2 }}>
                  {displayName}
                </Typography>

                <Typography variant="body2" sx={{ mr: 2 }}>
                  Plan: {subscription?.plan ?? 'loading'} | Credits: {subscription?.credits === -1 ? '∞' : subscription?.credits ?? 0}
                </Typography>

                {/* Upgrade button shown only if not paid */}
                {subscription && !isPaidPlan(subscription.plan) && (
                  <Button
                    color="secondary"
                    variant="contained"
                    size="small"
                    onClick={() => handleSubscribe('pro-monthly')}
                    sx={{ mr: 1 }}
                  >
                    Upgrade
                  </Button>
                )}

                <Button color="inherit" onClick={handleLogout}>Logout</Button>
              </>
            ) : (
              <Button color="inherit" onClick={handleLogin}>Login</Button>
            )}

            <Tooltip title="Toggle light/dark mode">
              <IconButton color="inherit" onClick={toggleDarkMode}>
                {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
              </IconButton>
            </Tooltip>
          </Toolbar>
        </AppBar>

        <Routes>
          {/* === Home page (your existing content) === */}
          <Route
            path="/"
            element={
              <Container sx={{ mt: 4 }}>
                <Box textAlign="center" mb={4}>
                  <Typography variant="h4" gutterBottom>YouTube Video Summarizer</Typography>
                  <Typography variant="subtitle1">Paste a YouTube URL below and get a transcript or summary.</Typography>

                  {!user && SHOW_AUTH_PANEL && (
                    <Card sx={{ mt: 3 }}>
                      <CardContent>
                        <Tabs value={authTab} onChange={(_, v: 'login'|'signup') => setAuthTab(v)} sx={{ mb: 2 }}>
                          <Tab label="Log in" value="login" />
                          <Tab label="Sign up" value="signup" />
                        </Tabs>

                        {authTab === 'login' && (
                          <>
                            <TextField
                              size="small"
                              label="Email"
                              type="email"
                              value={email}
                              onChange={(e)=>setEmail(e.target.value)}
                              sx={{ mr:1, mb:1 }}
                            />
                            <TextField
                              size="small"
                              label="Password"
                              type="password"
                              value={password}
                              onChange={(e)=>setPassword(e.target.value)}
                              sx={{ mr:1, mb:1 }}
                            />
                            <Button
                              variant="contained"
                              size="small"
                              onClick={handleSignIn}
                              disabled={authLoading}
                              sx={{ mr:1, mb:1 }}
                            >
                              Log in
                            </Button>
                            <Button
                              variant="text"
                              size="small"
                              onClick={handleResetPassword}
                              disabled={authLoading || !email}
                              sx={{ mb:1 }}
                            >
                              Forgot password?
                            </Button>

                            <Box sx={{ mt: 1 }}>
                              <Typography variant="caption" display="block" sx={{ mb: 1 }}>
                                Prefer Google?
                              </Typography>
                              <Button variant="outlined" size="small" onClick={handleLogin} disabled={authLoading}>
                                Continue with Google
                              </Button>
                            </Box>
                          </>
                        )}

                        {authTab === 'signup' && (
                          <>
                            <TextField
                              size="small"
                              label="Email"
                              type="email"
                              value={email}
                              onChange={(e)=>setEmail(e.target.value)}
                              sx={{ mr:1, mb:1 }}
                            />
                            <TextField
                              size="small"
                              label="Password"
                              type="password"
                              value={password}
                              onChange={(e)=>setPassword(e.target.value)}
                              sx={{ mr:1, mb:1 }}
                              helperText="Min 6 characters"
                            />
                            <Button
                              variant="contained"
                              size="small"
                              onClick={handleSignUp}
                              disabled={authLoading}
                              sx={{ mb:1 }}
                            >
                              Create account
                            </Button>

                            <Box sx={{ mt: 1 }}>
                              <Typography variant="caption" display="block" sx={{ mb: 1 }}>
                                Or sign up with Google
                              </Typography>
                              <Button variant="outlined" size="small" onClick={handleLogin} disabled={authLoading}>
                                Continue with Google
                              </Button>
                            </Box>

                            <Typography variant="caption" display="block" sx={{ mt: 2 }}>
                              By creating an account you agree to our{' '}
                              <RouterLink to="/terms">Terms</RouterLink> and{' '}
                              <RouterLink to="/privacy">Privacy Policy</RouterLink>.
                            </Typography>
                          </>
                        )}
                      </CardContent>
                    </Card>
                  )}

                  <Box mt={2} display="flex" justifyContent="center" alignItems="center">
                    <TextField id="url-input" placeholder="https://youtube.com/..." value={url} onChange={(e) => setUrl(e.target.value)} sx={{ width: '50%' }} variant="outlined" />
                    <Button variant="contained" sx={{ ml: 2 }} onClick={handleGenerate} disabled={loading}>
                      {loading ? <CircularProgress size={24} color="inherit" /> : 'Transcript'}
                    </Button>
                    <Button variant="outlined" sx={{ ml: 2 }} onClick={handleGenerateAndSummarize} disabled={loading}>
                      {loading ? <CircularProgress size={24} color="inherit" /> : 'Summary'}
                    </Button>
                  </Box>
                </Box>

                {(result || summary) && (
                  <Box>
                    <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 2 }}>
                      <Tab label="Transcript" />
                      <Tab label="Summary" />
                    </Tabs>

                    {tabIndex === 0 && result && (
                      <Box textAlign="left">
                        <Typography variant="h6" gutterBottom>
                          Transcript
                          <Tooltip title="Copy Transcript">
                            <IconButton onClick={() => handleCopy(result)} size="small">
                              <ContentCopyIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Download Transcript">
                            <IconButton onClick={() => handleDownload(result, 'transcript.txt')} size="small">
                              <DownloadIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Typography>
                        <Paper sx={{ p: 2, maxHeight: 400, overflowY: 'auto' }}>
                          {result.split('\n').map((line, idx) => (
                            <Typography key={idx} variant="body2" sx={{ mb: 0.5 }}>{line}</Typography>
                          ))}
                        </Paper>
                        {!summary && (
                          <Button variant="outlined" sx={{ mt: 2 }} onClick={handleSummarize} disabled={loading}>
                            {loading ? <CircularProgress size={24} color="inherit" /> : 'Summarize This Transcript'}
                          </Button>
                        )}
                      </Box>
                    )}

                    {tabIndex === 1 && summary && (
                      <Box textAlign="left">
                        <Typography variant="h6" gutterBottom>
                          Summary
                          <Tooltip title="Copy Summary">
                            <IconButton onClick={() => handleCopy(summary)} size="small">
                              <ContentCopyIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Download Summary">
                            <IconButton onClick={() => handleDownload(summary, 'summary.txt')} size="small">
                              <DownloadIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Typography>
                        <Paper sx={{ p: 2 }}>
                          <ReactMarkdown
                            components={{
                              p: ({ node, ...props }) => <Typography variant="body1" sx={{ mb: 1 }}>{props.children}</Typography>,
                              h1: ({ node, ...props }) => <Typography variant="h5" sx={{ mt: 2, mb: 1 }}>{props.children}</Typography>,
                              h2: ({ node, ...props }) => <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>{props.children}</Typography>,
                              ul: ({ node, ...props }) => <ul style={{ marginTop: 0, marginBottom: 8, paddingLeft: '1.2em' }}>{props.children}</ul>,
                              li: ({ node, ...props }) => <li style={{ marginBottom: 4 }}><Typography variant="body1" component="span">{props.children}</Typography></li>,
                            }}
                          >
                            {summary}
                          </ReactMarkdown>
                        </Paper>
                      </Box>
                    )}
                  </Box>
                )}

                <Box mt={8} mb={6}>
                  <Typography variant="h4" gutterBottom>Key Features</Typography>
                  <Grid container spacing={3}>
                    {features.map((feature) => (
                      <Grid item xs={12} md={4} key={feature.title}>
                        <Paper elevation={3} sx={{ p: 3, height: '100%' }}>
                          <Typography variant="h6">{feature.title}</Typography>
                          <Typography variant="body2">{feature.description}</Typography>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </Box>

                <Box mb={6}>
                  <Typography variant="h4" gutterBottom>How It Works</Typography>
                  <Grid container spacing={3}>
                    {steps.map(({ step, title, desc }) => (
                      <Grid item xs={12} md={4} key={step}>
                        <Paper elevation={3} sx={{ p: 3, height: '100%' }}>
                          <Typography variant="h6" gutterBottom>{step}</Typography>
                          <Typography variant="subtitle1" gutterBottom>{title}</Typography>
                          <Typography variant="body2">{desc}</Typography>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </Box>

                <Box mb={6}>
                  <Typography variant="h4" gutterBottom>Testimonials</Typography>
                  <Grid container spacing={3}>
                    {testimonials.map(({ name, role, quote }) => (
                      <Grid item xs={12} md={4} key={name}>
                        <Paper elevation={3} sx={{ p: 3 }}>
                          <Typography variant="body1" gutterBottom>“{quote}”</Typography>
                          <Typography variant="subtitle2">{name} – {role}</Typography>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </Box>

                <Box mb={6}>
                  <Typography variant="h4" gutterBottom>Frequently Asked Questions</Typography>
                  {faq.map(({ question, answer }) => (
                    <Accordion key={question}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>{question}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>{answer}</Typography>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </Box>

                
                {/* Pricing / Plans */}
                {(!user || (subscription?.plan?.toLowerCase() !== 'pro')) && (
                  <Box mb={6}>
                    <Typography variant="h4" gutterBottom>Powerful Features, Affordable Plans</Typography>

                    <Grid container spacing={3} justifyContent="center">
                      {/* Anonymous — show only if not logged in */}
                      {!user && (
                        <Grid item xs={12} md={4}>
                          <Paper elevation={3} sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <Box>
                              <Typography variant="h6" gutterBottom><strong>Anonymous</strong></Typography>
                              <Typography variant="body2" sx={{ mb: 2 }}>No account required.</Typography>
                              <Typography variant="body2" sx={{ mb: 1 }}>✓ 5 credits/day</Typography>
                              <Typography variant="body2" sx={{ mb: 1 }}>✓ Access transcripts & summaries</Typography>
                            </Box>
                            <Button
                              variant="contained"
                              sx={{ mt: 2 }}
                              onClick={() => document.getElementById('url-input')?.focus()}
                            >
                              Try Free Now
                            </Button>
                          </Paper>
                        </Grid>
                      )}

                      {/* Free (login) */}
                      <Grid item xs={12} md={4}>
                        <Paper elevation={3} sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                          <Box>
                            <Typography variant="h6" gutterBottom><strong>Free Plan</strong></Typography>
                            <Typography variant="body2" sx={{ mb: 2 }}>Activated on login — no credit card required.</Typography>
                            <Typography variant="body2" sx={{ mb: 1 }}>✓ 30 credits/day</Typography>
                            <Typography variant="body2" sx={{ mb: 1 }}>✓ Access transcripts & summaries</Typography>
                          </Box>
                          {user ? (
                            <Button variant="outlined" sx={{ mt: 2 }} disabled>
                              {subscription?.plan?.toLowerCase() === 'free' ? 'You’re on Free' : 'Logged In'}
                            </Button>
                          ) : (
                            <Button variant="contained" sx={{ mt: 2 }} onClick={handleLogin}>
                              Log In to Activate
                            </Button>
                          )}
                        </Paper>
                      </Grid>

                      {/* Pro */}
                      <Grid item xs={12} md={4}>
                        <Paper elevation={3} sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                          <Box>
                            <Typography variant="h6" gutterBottom><strong>Pro Plan</strong></Typography>
                            <Typography variant="body2" sx={{ mb: 2 }}>$3.99 / month</Typography>
                            <Typography variant="body2" sx={{ mb: 1 }}>✓ 2000 credits/month</Typography>
                            <Typography variant="body2" sx={{ mb: 1 }}>✓ Faster queue / priority</Typography>
                            <Typography variant="body2" sx={{ mb: 1 }}>✓ Access transcripts & summaries</Typography>
                          </Box>

                          {subscription?.plan?.toLowerCase() === 'pro' ? (
                            <Button variant="outlined" sx={{ mt: 2 }} onClick={handleManageSubscription}>
                              Manage Subscription
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              sx={{ mt: 2 }}
                              onClick={() => {
                                if (!user) { handleLogin(); return; }
                                handleSubscribe('pro-monthly');
                              }}
                            >
                              Upgrade to Pro
                            </Button>
                          )}
                        </Paper>
                      </Grid>
                    </Grid>
                  </Box>
                )}




                <Box textAlign="center" mb={6}>
                  <Typography variant="h5" gutterBottom>Ready to save time summarizing YouTube videos?</Typography>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => document.getElementById('url-input')?.focus()}
                  >
                    Try It Now
                  </Button>
                </Box>

                {/* Footer (use RouterLink + subtle Manage subscription) */}
                <Box bgcolor="background.paper" p={3} textAlign="center">
                  <Typography variant="body2">
                    © 2025 Mtinnotech |
                    {' '}<RouterLink to="/privacy">Privacy</RouterLink> |
                    {' '}<RouterLink to="/terms">Terms</RouterLink> |
                    {' '}<RouterLink to="/contact">Contact</RouterLink>
                    {user && (
                      <>
                        {' '}|{' '}
                        <Button variant="text" onClick={handleManageSubscription} sx={{ textDecoration: 'none', p: 0, minWidth: 0 }}>
                          Manage subscription
                        </Button>

                      </>
                    )}
                  </Typography>
                </Box>

                <Snackbar open={toastOpen} autoHideDuration={4000} onClose={() => setToastOpen(false)}>
                  <Alert onClose={() => setToastOpen(false)} severity={toastSeverity} sx={{ width: '100%' }}>
                    {toastMsg}
                  </Alert>
                </Snackbar>
              </Container>
            }
          />

          {/* === Static pages === */}
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </HelmetProvider>
);
}